export default function () {
  return {
    list: []
  }
}
